import { showErrorToast } from 'helpers/toasts';

import type { TranscriptionHandler, WEBSpeechAPIHandlerProps } from './types';

export const SpeechRecognition =
  // @ts-ignore
  window.SpeechRecognition || window.webkitSpeechRecognition;

let startTime = new Date();
export default function HandleWebSpeechAPI({
  sendToServer,
}: WEBSpeechAPIHandlerProps): TranscriptionHandler {
  // @ts-ignore
  let recognition: SpeechRecognition = null;
  let stopped = true;

  const initTranscribeHandler = () => {
    recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.processLocally = true;
    recognition.lang = 'en-US';
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;

    recognition.addEventListener('end', () => {
      if (!stopped) {
        try {
          console.log('RE-START');
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          startTranscription();
        } catch {
          stopped = true;
        }
      } else {
        stopped = true;
      }
    });

    recognition.onresult = (event: any) => {
      const n = event.results.length - 1;
      const lastItem = event.results[n];

      if (lastItem?.isFinal) {
        const endDate = new Date();
        const endDuration = (endDate.getTime() - startTime.getTime()) / 1000;
        const text = event.results[n][0].transcript;
        sendToServer({ text, end: endDuration, source: 'browser_web_speech_api' });
      }

      if (stopped) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopTranscription();
      }
    };

    recognition.onerror = ({ error }: { error: string }) => {
      if (error !== 'aborted') {
        showErrorToast('Some error occured');
      }
    };
  };

  const startTranscription = () => {
    stopped = false;
    if (!recognition) initTranscribeHandler();

    try {
      recognition.start();
      startTime = new Date();
      console.log('START');
    } catch (err) {
      console.log(err);
    }
  };

  const stopTranscription = async () => {
    if (!recognition) return;
    stopped = true;

    try {
      console.log('STOP');
      recognition.stop();
    } catch (err) {
      console.log(err);
    }
  };

  const cleanUpTranscription = () => {
    if (!recognition) return;

    stopped = true;
    recognition.abort();
    recognition = null;
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  const changeAudioDevice = () => { };

  return {
    initTranscribeHandler,
    startTranscription,
    stopTranscription,
    changeAudioDevice,
    cleanUpTranscription,
  };
}
